import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enGB from './locales/en-GB.json';
import enUS from './locales/en-US.json';
import { config, DEFAULT_LOCALE } from '../config/environment';
const ALL_RESOURCES = {
    'en-GB': { translation: enGB },
    'en-US': { translation: enUS }
};
// Only locales whitelisted via REACT_APP_SUPPORTED_LOCALES are registered. A
// locale that is not fully translated is therefore not served at all: its users
// get DEFAULT_LOCALE in full rather than a UI mixing translated and blank
// strings. Completeness is tracked in Lokalise, which exports untranslated keys
// as empty strings — values i18next would otherwise render as blank text.
const supportedLocales = config.supportedLocales.filter((locale) => locale in ALL_RESOURCES);
const resources = supportedLocales.reduce((acc, locale) => {
    acc[locale] = ALL_RESOURCES[locale];
    return acc;
}, {});
const languageToLocaleMap = {
    en: DEFAULT_LOCALE
};
const detectBrowserLocale = () => {
    var _a;
    if (typeof navigator === 'undefined')
        return DEFAULT_LOCALE;
    const browserLocales = (_a = navigator.languages) !== null && _a !== void 0 ? _a : [navigator.language];
    for (const locale of browserLocales) {
        // Exact match (e.g. "en-US" → "en-US")
        if (supportedLocales.includes(locale))
            return locale;
        // Language-only fallback (e.g. "en" → "en-US", "es-AR" → "es-MX")
        const lang = locale.split('-')[0];
        const mappedLocale = languageToLocaleMap[lang];
        if (mappedLocale && supportedLocales.includes(mappedLocale))
            return mappedLocale;
    }
    return DEFAULT_LOCALE;
};
const i18n = createInstance();
i18n.use(initReactI18next).init({
    resources,
    lng: detectBrowserLocale(),
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
        escapeValue: false
    }
});
export default i18n;
